import React, {useEffect} from 'react';
import {
  DiHtml5,
  DiCss3,
  DiJsBadge,
  DiBootstrap,
  DiSass,
  DiReact
} from 'react-icons/di'
import AOS from 'aos'
import 'aos/dist/aos.css';

import './tecnologies.css'

const technologies = [
  { id: "html", name: "HTML5", icon: <DiHtml5 />,  delay: "600"},
  { id: "css", name: "CSS3", icon: <DiCss3 />, delay: "750" },
  { id: "js", name: "JavaScript", icon: <DiJsBadge />, delay: "950" },
  { id: "react", name: "React", icon: <DiReact />, delay: "1150" },
  { id: "sass", name: "Sass", icon: <DiSass />, delay: "1350" },
  { id: "bootstrap", name: "Bootstrap", icon: <DiBootstrap />, delay: "1550" },
  
]

const Tecnologies = () => {
  useEffect(() => {
    AOS.init({duration: 800})
  }, []);
  return (
    <section className="technologies-container">
      <div className="technologie-about" data-aos="fade-up" data-aos-anchor-placement="top-bottom" data-aos-delay="400">
        <p className="about-experince">I'm a developer that, continually pursue improvement, working as freelancer since end of 2019, I'm constantly learning and challenge my-self every day. Below are my most used technologies, however I'm not limited to it, having worked previously with PHP and Python in a couple of cooperative projects.</p>
      </div>
      <div className="technologies-flex">
        {technologies.map((tech) => (
          <div className="technologies-card" id={tech.id} key={tech.id}>
            <div data-aos="fade-up" data-aos-anchor-placement="top-bottom" data-aos-delay={tech.delay}><h3>{tech.name}</h3></div>
            <div data-aos="fade-up" data-aos-anchor-placement="top-bottom" data-aos-delay={tech.delay}>{tech.icon}</div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Tecnologies;
